import React, {Fragment, useMemo, useState} from 'react';
import {createBackgroundElements} from '../../../../util/WDRUtils';
import ArdItem from '../../../../modules/Ard/components/ArdItem';
import {
  calcHidden,
  calcInitialPosition
} from '../../../../util/calculateInitialItemValues';
import {SingleInputItem, IconItem} from '../MapItems/MapItems.js';
import {WDRWindItem} from '../wdr/WDRWindItem';
import {WDRLineGraph} from '../wdr/WDRLineGraph';
import {WDRIconItem} from '../wdr/WDRIconItem';
import {WDRIconItemSA} from '../wdr/WDRIconItemSA';
import {WDRIconItemPrognose} from '../wdr/WDRIconItemPrognose';
import BRItem from '../br/BRItem';
import {MapToolbar} from '../MapToolbar';
import './MapView1.scss';
import './RBB.css';

export const MapViewDefault = props => {
  const mapScale = props.mapScale || 0.5;
  const currentMap = props.map;
  const items = currentMap.items;

  const broadcaster = useMemo(
    () =>
      props.data && props.data.broadcaster
        ? props.data.broadcaster.toLowerCase()
        : '',
    [props.data]
  );

  const [renderViewSelected, setRenderViewSelected] = useState(
    Boolean(props.renderView)
  );

  const handleRenderViewSelected = () => {
    setRenderViewSelected(!renderViewSelected);
    setRenderView(!renderViewSelected);
  };

  const childRefs = [...Array(Object.entries(items).length).keys()].map(() =>
    React.createRef()
  );

  const lockAllItems = () =>
    childRefs.forEach(c => {
      c.current.check(true);
    });
  const unlockAllItems = () =>
    childRefs.forEach(c => {
      c.current.check(false);
    });
  const restoreItemLocations = () =>
    childRefs.forEach(c => c.current.resetPosition());
  const setRenderView = state =>
    childRefs.forEach(c => {
      c.current.setRenderView(state);
    });

  return (
    <div className='mapview-wrapper'>
      <div className='mapview-scaling'>
        <div
          className='mapview'
          style={{
            backgroundColor: 'white',
            backgroundImage: `url( ${currentMap.backgroundImage} )`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat'
          }}>
          {Object.keys(items).map((key, i) => {
            const item = items[key];

            const dataKey = Object.keys(item.data)[0];

            if (item.type === 'value-with-unit') {
              return (
                <SingleInputItem
                  setValueInMap={props.setValueInMap}
                  item={item}
                  data={{
                    key: dataKey,
                    value: item.data[dataKey].value,
                    lastUpdate: item.data[dataKey].lastUpdate
                  }}
                  key={i}
                  mapScale={mapScale}
                />
              );
            } else if (item.type === 'icon') {
              return (
                <IconItem
                  setValueInMap={props.setValueInMap}
                  item={item}
                  data={{
                    key: dataKey,
                    value: item.data[dataKey].value,
                    lastUpdate: item.data[dataKey].lastUpdate
                  }}
                  key={i}
                  mapScale={mapScale}
                />
              );
            } else if (item.type === 'wdr-wind') {
              return (
                <WDRWindItem
                  setValueInMap={props.setValueInMap}
                  item={item}
                  key={i}
                  mapScale={mapScale}
                />
              );
            } else if (item.type === 'wdr-icon') {
              return (
                <WDRIconItem
                  setValueInMap={props.setValueInMap}
                  item={item}
                  key={i}
                  mapScale={mapScale}
                />
              );
            } else if (item.type === 'wdr-icon-prognose') {
              return (
                <WDRIconItemPrognose
                  setValueInMap={props.setValueInMap}
                  item={item}
                  key={i}
                  mapScale={mapScale}
                />
              );
            } else if (item.type === 'wdr-icon2') {
              return (
                <WDRIconItemSA
                  setValueInMap={props.setValueInMap}
                  item={item}
                  key={i}
                  mapScale={mapScale}
                />
              );
            } else if (item.type === 'wdr-tendenz') {
              return (
                <WDRLineGraph
                  key={item.id}
                  scale={mapScale}
                  position={item.position}
                  size={item.size}
                  item={item}
                  onChange={props.setValueInMap}
                />
              );
            } else if (
              item.type === 'br-icon' ||
              item.type === 'br-danger' ||
              item.type === 'br-temperature'
            ) {
              return (
                <BRItem
                  initialPosition={calcInitialPosition(item, props.parentData)}
                  hidden={calcHidden(item)}
                  key={i}
                  childRef={childRefs[i]}
                  item={item}
                  data={props.data}
                  parentData={props.parentData}
                  mapScale={mapScale}
                  renderView={renderViewSelected}
                  setValueInMap={props.setValueInMap}
                />
              );
            } else if (broadcaster.startsWith('ard')) {
              return (
                <ArdItem
                  key={`${
                    currentMap ? currentMap.id : Date.now().toString()
                  }_${i}`}
                  currentMap={currentMap}
                  item={item}
                  broadcaster={(props.data || {}).broadcaster}
                  parentData={props.parentData}
                  mapScale={mapScale}
                  setValueInMap={props.setValueInMap}
                />
              );
            } else {
              return <Fragment key={i} />;
            }
          })}
          {createBackgroundElements(currentMap)}
        </div>
      </div>
      {props.broadcaster === 'BR' && (
        <MapToolbar
          renderView={false}
          onLock={lockAllItems}
          onUnlock={unlockAllItems}
          onReset={restoreItemLocations}
          onToggle={handleRenderViewSelected}
        />
      )}
    </div>
  );
};

export default MapViewDefault;
